import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/esm/objectWithoutPropertiesLoose';
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
export const breakpointKeys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.
export const createBreakpoints = (breakpoints) => {
    const { 
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920
    }, unit = 'px', step = 5 } = breakpoints, other = _objectWithoutPropertiesLoose(breakpoints, [
        'values',
        'unit',
        'step'
    ]);
    const keys = Object.keys(values);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return (`@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` +
            `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number'
                ? values[keys[endIndex]]
                : end) -
                step / 100}${unit})`);
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) {
            return between(key, keys[keys.indexOf(key) + 1]);
        }
        return up(key);
    }
    function width(key) {
        return values[key];
    }
    return _extends({
        keys,
        values,
        up,
        down,
        between,
        only,
        width,
        unit
    }, other);
};
//# sourceMappingURL=createBreakpoints.js.map